import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { urlStructureAdminCenter } from '../../../routing/routingPaths';

export const TRIAL_PLAN_NAME = 'Cube Trial';

export const useTrialWorkspaceCheck = () => {
  const workspace = useCurrentWorkspace()[1];
  const history = useHistory();

  const expireAt = workspace?.expires_at;
  const hasExpired = expireAt && new Date(expireAt) < new Date();

  const onClickUpgrade = useCallback(() => {
    if (!workspace) return;
    const url = generatePath(urlStructureAdminCenter, {
      workspaceId: workspace.id,
      subroute: 'plan-and-billing'
    });
    history.push(url);
  }, [workspace]);

  const isTrial =
    workspace &&
    workspace.plan_name === TRIAL_PLAN_NAME &&
    !workspace.has_subscription;

  return {
    isTrial,
    hasExpired,
    expireAt,
    plan: workspace?.plan_name,
    haSubscription: workspace?.has_subscription,
    onClickUpgrade
  };
};
